import React from 'react';
import env from 'env';
import { Table } from 'components/table/table';
import { useGet } from 'components';
import utils from 'utils';
import { SiteLink } from 'components';
import { Loading, ErrorPopup } from 'components';

export function ProductList(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Product Name',
        accessor: 'productName',
        Cell: (c) => {
          //console.log(c)
          return (<SiteLink to={`/admin/product/edit/${c.row.values.productCode}`}><b>{c.cell.value}</b></SiteLink>)
        }
      },
      {
        Header: 'Product Code',
        accessor: 'productCode',
      },
      {
        Header: 'Sorting Order',
        accessor: 'sortingOrder',
      },
      {
        Header: 'Status AU',
        accessor: 'productStatusTextAU',
      },
      {
        Header: 'Status NZ',
        accessor: 'productStatusTextNZ',
      },
      {
        Header: 'Trending Now',
        accessor: 'trendingNow',
        Cell: (c) => {
          return !!c.cell.value ? 'Y' : ''
        }
      },
      {
        Header: 'Cat 1',
        accessor: 'category',
      },
      {
        Header: 'Price AU',
        accessor: 'priceAU',
        Cell: (c) => c.cell.value && utils.money.formatMoney(c.cell.value)
      },
      {
        Header: 'Price NZ',
        accessor: 'priceNZ',
        Cell: (c) => c.cell.value && utils.money.formatMoney(c.cell.value)
      }
    ],
    []
  )

  // const [filterWM, setFilterWM] = React.useState(window.localStorage.getItem('filterWM') || 'W');
  const [filterKeyword, setFilterKeyword] = React.useState(window.localStorage.getItem('filterKeyword') || '');
  const get = useGet();

  React.useEffect(() => {
    get.send(env.apiBase + '/api/productAdmin/getProducts');
    //get.send(env.apiBase + '/api/productAdmin/getProducts?q=' + encodeURIComponent(filterKeyword));
    //get.send(env.apiBase + '/api/productAdmin/getProducts?wm=' + filterWM);
    // eslint-disable-next-line
  }, []); //filterWM
  
  if (get.loading()) {
    return <Loading />
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  // const changeFilterWM = (e) => {
  //   setFilterWM(e.target.value)
  //   window.localStorage.setItem('filterWM', e.target.value);
  // }

  const changeFilterKeyword = (e) => {
    setFilterKeyword(e.target.value)
    window.localStorage.setItem('filterKeyword', e.target.value);
  }

  function filterList(data) {
    let filtered = data;
    if (filterKeyword) {
      filtered = filtered.filter(x => searchInField(x.productCode, filterKeyword) || searchInField(x.productName, filterKeyword))
    }
    return filtered;
  }

  function searchInField(str, search_str) {
    if (!str || !search_str) return false;
    const result = str.search(new RegExp(escapeRegExp(search_str), "i"));
    return result >= 0
  }

  function escapeRegExp(str) {
    // eslint-disable-next-line
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  }

  function removeFilter() {
    setFilterKeyword('')
    window.localStorage.setItem('filterKeyword', '');
  }

//  console.log(get)
  const data = get.response;
  const filtered = filterList(data);
  //console.log(filtered)

  return (
    <>
      <h1>Products</h1>
      <div className="filter" style={{minHeight:'30px'}}>
        <SiteLink className="btn btn-outline-primary" to="/admin/product/new">Add Product</SiteLink>
        <div style={{float:'right', display:'flex', alignItems:'center'}}>
          <input className="form-control" type="text" placeholder="Search" value={filterKeyword} onChange={changeFilterKeyword}/>
          {filterKeyword && <span style={{display:'inlne-block', fontSize:'0.8rem', color: 'chocolate', marginLeft: '10px', cursor: 'pointer'}} onClick={removeFilter}>clear filter</span>}
        </div>
        {/* <select name="wm" type="select" className="form-control" value={filterWM} onChange={changeFilterWM}>
          <option value="all">All</option>
          <option value="W">Women</option>
          <option value="M">Men</option>
        </select> */}
      </div>
      <Table columns={columns} data={filtered} />
    </>
  );
}
